import {Component, h} from "@stencil/core";


@Component({
  tag: "button-link-group",
  styleUrl: "button-link-group-component.scss",
  shadow: false
})
export class ButtonLinkGroupComponent {

  public static readonly TAG_NAME = "button-link-group";

  render() {
    return (
        <slot></slot>
    )
  }
}
